import { createAction } from "@reduxjs/toolkit";
import * as types from "../types/actions";

export const getRentals = createAction(types.GETRENTALS);

export const createToast = createAction(types.CREATE_TOAST);
export const deleteToast = createAction(types.DELETE_TOAST);
export const openPopper = createAction(types.OPEN_POPPER);
export const closePopper = createAction(types.CLOSE_POPPER);
export const updatePhotos = createAction(types.UPDATE_PHOTOS);
export const refreshPhotos = createAction(types.REFRESH_PHOTOS);
